import * as R from 'ramda'
import {
    FETCH_LINES_SUCCESS,
    FETCH_ADDED_LINE_SUCCESS
} from '../actionTypes'

const initialState = []

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case(FETCH_LINES_SUCCESS):
            return payload && [...Object.keys(payload)]
        case(FETCH_ADDED_LINE_SUCCESS):
            return payload ? [...Object.keys(payload)] : []
        /*case(ADD_LINE_SUCCESS):
            const ids = Object.keys(payload);
            return [...ids]*/
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/linesIds.js